import { render, staticRenderFns } from "./GrowingNumber.vue?vue&type=template&id=263c8b93&"
import script from "./GrowingNumber.vue?vue&type=script&lang=ts&"
export * from "./GrowingNumber.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports